import { render } from "./SuperOffers.vue?vue&type=template&id=2add5145&scoped=true&ts=true"
import script from "./SuperOffers.vue?vue&type=script&lang=ts"
export * from "./SuperOffers.vue?vue&type=script&lang=ts"

import "./SuperOffers.vue?vue&type=style&index=0&id=2add5145&lang=scss&scoped=true"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2add5145"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCarousel,QCarouselSlide,QTooltip});
